import styled from 'styled-components';

import { hexa, media } from 'legacyComponents/styled/styleUtils';
import Button from 'components/Button';

export const TOOLBAR_SPACING = 46;

export const StyledPreviewViewer = styled.div`
  width: 100%;
  height: 680px;
  outline: none;
  overflow: hidden;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  cursor: grab;
  &:active {
    cursor: grabbing;
  }
  ${media.l`
    width: 100%;
    height: 620px;
`}
  ${media.m`
    width: 100%;
    height: 440px;
`}
  ${media.s`
    width: 100%;
    height: 350px;
`}
  ${media.xs`
    width: 100%;
    height: 380px;
`}`;

// export const TextareaEditor = styled.textarea`
//   width: calc(100% + 2px);
//   position: absolute;
//   top: -1px;
//   /* Fixed value for recovering the note for formatting showed under this layer */
//   bottom: -26px;
//   left: -1px;
//   /* TODO: change fixed values by theme values once input component can be refactorized */
//   padding: 10px;
//   border: 1px solid ${props => props.theme.color.wfGrey300};
//   z-index: 5;
//   &:focus {
//     border-color: ${props => props.theme.color.wfGrey500};
//   }
// `;

export const TextareaEditor = styled.textarea(({ theme }) => {
  return {
    marginTop: theme.space[2],
    minHeight: 40,
    display: 'block',
    width: '100%',
    overflow: 'hidden',
    resize: 'none',
    // '::before': {
    //   display: 'block',
    //   content: "'Leave a message...'",
    //   color: theme.color.wfGrey500,
    // },
  };
});

export const BlockPreview = styled.div`
  box-shadow: ${props =>
    props.isSelected
      ? `0 0 0 2px ${props.theme.color.primary}`
      : 'box-shadow: 0 1px 1px rgba(44, 45, 48, 0.07);'};
  margin: 0 2px;
  ${StyledPreviewViewer} {
    height: auto;
  }
`;

export const InlinePreview = styled.span``;

export const FinderWrapper = styled.div`
  height: 600px;
`;

// FIXME - Once content has been migrated from HTML to MD, change to max-width
export const InlineImage = styled.span`
  display: inline;
  > img {
    width: 100%;
    box-shadow: ${props =>
      props.selected ? `0 0 0 2px ${props.theme.color.primary}` : 'none'};
  }
`;

export const BlockImage = styled.div`
  display: block;
  margin: 0 auto;
  > img {
    width: 100%;
    height: auto;
    box-shadow: ${props =>
      props.selected ? `0 0 0 2px ${props.theme.color.primary}` : 'none'};
    margin: 0 auto;
  }
`;

export const InlineVideo = styled.span`
  display: inline-block;
  width: 100%;
  text-align: center;
  height: 0;
  position: relative;
  padding-bottom: 56.25%;
  overflow: hidden;
  box-shadow: ${props =>
    props.selected ? `0 0 0 2px ${props.theme.color.primary}` : 'none'};
  > iframe {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export const BlockVideo = styled.div`
  width: 100%;
  height: 0;
  position: relative;
  padding-bottom: 56.25%;
  overflow: hidden;
  box-shadow: ${props =>
    props.selected ? `0 0 0 2px ${props.theme.color.primary}` : 'none'};
  > iframe {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export const Code = styled.code`
  padding: 0 2px;
  background-color: ${props => props.theme.color.wfGrey200};
  border: 1px solid ${props => props.theme.color.wfGrey300};
  font-size: 0.8em;
  color: ${props => props.theme.color.primary};
`;

export const CodeBlock = styled.div`
  padding: 4px;
  background-color: ${props => props.theme.color.wfGrey300};
  border: 1px solid ${props => props.theme.color.wfGrey300};
  color: ${props => props.theme.color.wfGrey};
  width: 100%;
  display: block;
  overflow-x: scroll;
`;

export const H1 = styled.h1`
  font-size: 1.5em;
`;

export const H2 = styled.h2`
  font-size: 1.3em;
`;

export const H3 = styled.h3`
  font-size: 1em;
  margin-bottom: 10px;
  margin-top: 0px;
`;

export const H4 = styled.h4`
  font-size: 0.9em;
  text-transform: uppercase;
  margin-bottom: 10px;
  margin-top: 0px;
`;

export const OL = styled.ol`
  margin-top: 10px;
  margin-bottom: 0px;
`;

export const UL = styled.ul`
  margin-top: 10px;
  margin-bottom: 0px;
`;

export const LinkStyle = styled.a`
  color: ${props => props.theme.color.primary};
  font-weight: 600;
  text-decoration: underline;
  word-break: break-word;
  s &:hover {
    cursor: pointer;
  }
`;

export const FakeLink = styled.span`
  font-size: 0.9em;
  color: ${props => props.theme.color.primary};
  word-break: break-word;
  font-weight: ${props => (props.mention ? '400' : '600')};
  background-color: ${props =>
    props.mention ? `${hexa(props.theme.color.primary, 0.1)}` : 'transparent'};
  border: ${props =>
    props.mention
      ? `1px solid ${hexa(props.theme.color.primary, 0.2)}`
      : 'transparent'};
  border-radius: ${props => (props.mention ? '3px' : '0px')};
  padding: ${props => (props.mention ? '2px 4px' : '0px')};
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;

export const Quote = styled.blockquote`
  box-shadow: -5px 0px 0px 0px rgba(69, 127, 202, 1);
  padding: 10px 20px;
  font-style: italic;
  color: ${props => props.theme.color.wfGrey500};
  font-size: 19px;
  background-color: ${props => props.theme.color.wfGrey100};
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  border-top: 1px solid ${props => props.theme.color.wfGrey200};
  border-right: 1px solid ${props => props.theme.color.wfGrey200};
  border-bottom: 1px solid ${props => props.theme.color.wfGrey200};
  margin: 0px 40px;
`;

export const ToolbarStyle = styled.div`
  position: absolute;
  min-width: ${props => props.minWidth}px;
  z-index: 1015;
  top: ${props => props.top}px;
  left: ${props => props.left}px;
  margin-top: -6px;
  background-color: ${props => props.theme.color.wfBlack};
  border-radius: ${props => props.borderRadius}px;
  height: 46px;
  padding: 0px 20px;
  transition: opacity 0.75s;
  width: ${props => props.width};
`;

export const MediaMenuStyleOld = styled.div`
  position: absolute;
  /* TODO: Replace z-index values by theme ordered values */
  z-index: 1020;
  display: flex;
  align-items: center;
  opacity: ${props => props.opacity};
  top: ${props => props.top}px;
  left: ${props => props.left}px;
  transition: opacity 250ms ease-in-out, background-color 250ms ease-in-out;
  bottom: ${props => props.bottom} !important;
  height: 50px;
`;

export const MenuButton = styled(Button)`
  transform: ${props => props.rotated && 'rotate(45deg)'};
  transition: transform 200ms ease-in-out;
  margin: 0 ${props => props.theme.spacing.xsmall};
  &:first-of-type {
    margin-right: ${props => props.theme.spacing.default};
  }
`;

export const HiddenInput = styled.input`
  cursor: pointer;
  position: absolute;
  display: none;
  top: 0;
  left: 0;
  font-size: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
`;

export const ToolbarSeparator = styled.div`
  float: left;
  height: 46px;
  width: 18px;
`;

export const EditorWrapper = styled.div`
  /* position: relative; */
`;
